import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicEvent, UpdateEventDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const updateEvent = async ({
  orgId,
  eventId,
  event,
}: {
  orgId: string;
  eventId: string;
  event: UpdateEventDto;
}) => {
  const response = await axiosClient.patch(`${orgId}/events/${eventId}`, event);
  return response.data;
};

export function useUpdateEvent(
  queryOptions?: UseMutationOptions<
    PublicEvent,
    HttpError,
    { orgId: string; eventId: string; event: UpdateEventDto }
  >,
) {
  return useMutation({
    mutationFn: updateEvent,
    ...queryOptions,
  });
}
